// Vue
import { Observer } from "mobx-vue";
import { Component } from "vue-property-decorator";
// Template
import template from "./template.vue";
// Base Module
import ModuleBase from "#/common/ModuleBase";
// Components
import ModuleWrapper from "#/components/module_wrapper/ModuleWrapper";
import { ModuleList } from "#/components/module_list/ModuleList";
import { Api } from "#/api";
import { DashboardTile } from "@mgs/ci2019-common/src/interfaces/DashboardTile";
import { addTokenParameter } from "../../../common/Utils";

@Observer
@Component({
  mixins: [template],
  components: {
    ModuleWrapper,
    ModuleList,
  },
})
export class KatalogSelectionModule extends ModuleBase {
  public getBackgroundColorFromInstance(instance: object) {
    return "white";
  }

  public tiles: Array<DashboardTile> = [];

  public created() {
    this.getTiles();
  }

  get kachelIds() {
    return this.instance["kataloge"].map((entry) => {
      return entry["kachel_id"];
    });
  }

  get tileHeight() {
    return this.instance["tile_size"] == "small" ? 200 : 280;
  }

  get showTileImage() {
    return this.instance["tile_size"] == "small" ? false : true;
  }

  public async getTiles() {
    if (this.$store.page.page) {
      let tiles = await Api.dashboardService.getTiles(
        this.$store.page.page.portal.id,
        this.kachelIds,
        this.$store.page.isInEditMode
      );
      for (let i = 0; i < tiles.length; i++) {
        tiles[i]["dialogVisible"] = false;
      }
      this.tiles = tiles;
    }
  }

  get visibleTiles() {
    if (this.instance["kataloge"]) {
      return this.kachelIds
        .map((id) => {
          return this.tiles.find((tile) => tile.id == id);
        })
        .filter((x) => x !== undefined)
        .filter((x) => x.preview);
    } else {
      return [];
    }
  }

  public tileLink(link) {
    let token = this.$store.typeSelectionFilter.getToken();

    return addTokenParameter(link, token);
  }

  public isVisible(tile) {
    if (tile.kachel.katalog) {
      return (
        tile.preview.content.deactivate ||
        this.$store.typeSelectionFilter
          .getCatalogIds()
          .indexOf(tile.kachel.katalog) >= 0
      );
    } else {
      return true;
    }
  }

  public isActive(tile) {
    if (this.isDeactivate(tile)) {
      return false;
    } else {
      return (
        tile.kachel.katalog == null ||
        this.$store.typeSelectionFilter.activeCatalogs.indexOf(
          tile.kachel.katalog
        ) >= 0
      );
    }
  }

  public isDeactivate(tile) {
    return (
      tile.preview.content.deactivate &&
      tile.kachel.katalog &&
      this.$store.typeSelectionFilter.getCount(tile.kachel.katalog) === 0
    );
  }

  public tileTheme(tile) {
    if (tile.show_company_migration_notice) {
      return "locked";
    }

    if (this.isActive(tile)) {
      return "default";
    } else {
      return "locked";
    }
  }

  public getHref(tile) {
    if (tile.show_company_migration_notice) {
      return "/--/--/nicht-aktiviert";
    }

    if (this.isActive(tile) && tile.preview.content.link.href) {
      return this.tileLink(tile.preview.content.link.href);
    }

    return "#";
  }

  public tileTitle(tile) {
    let title = tile.preview.content.title;

    if (tile.kachel.katalog) {
      let count = this.$store.typeSelectionFilter.getCount(tile.kachel.katalog);
      if (count && count > 0) {
        title += " (" + count + ")";
      }
    }

    return title;
  }

  public hasError(catalogId) {
    return this.$store.typeSelectionFilter.hasError(catalogId);
  }

  public getError(catalogId) {
    return this.$store.typeSelectionFilter.getError(catalogId);
  }

  public isBackVisible(tile) {
    if (tile.show_company_migration_notice) {
      return false;
    }

    if (tile.kachel["katalog"] == "cloudvan") {
      return !this.isActive(tile);
    } else if (tile.preview["content"].deactivate) {
      return (
        !(tile.kachel.katalog && this.hasError(tile.kachel.katalog)) &&
        this.isDeactivate(tile)
      );
    } else {
      return tile.content && tile.content.length > 0;
    }
  }
}
